import { Box, Text } from '@mantine/core';
import { useParams } from 'react-router-dom';
import PageHeaderComponent from '@/design/PageHeaderComponent';

const PAGE_TITLES: Record<string, string> = {
    licenses: 'Licenses',
    users: 'Users',
    context: 'Context Engine',
};

export default function PlaceholderPage() {
    const { page } = useParams<{ page: string }>();
    const title = PAGE_TITLES[page ?? ''] ?? page ?? 'Unknown';

    return (
        <Box>
            <PageHeaderComponent title={title} subtitle="This page is under construction. Migration pending." />
            <Box
                p="xl"
                style={{
                    border: '1px dashed var(--bm-color-border)',
                    borderRadius: 'var(--bm-radius)',
                    textAlign: 'center',
                }}
            >
                <Text size="sm" c="dimmed" ff="monospace" fw={600}>
                    {title}
                </Text>
            </Box>
        </Box>
    );
}
